import APIClient from '@/shared/http/clients/api'

const APIBusiness = process.env.APIBaseURLBusinessCommon
const resourceName = 'Obra'

const GetTeam = (obraId, data = {}, config = {}) => APIClient.get(`${APIBusiness}/${resourceName}/membros/${obraId}`, data, config)
const GetWork = (id, data = {}, config = {}) => APIClient.get(`${APIBusiness}/${resourceName}/${id}`, data, config)
const GetWorkByRef = (data = {}, config = {}) => APIClient.post(`${APIBusiness}/${resourceName}/empresa/referencia`, data, config)
const PutStatus = (data = {}, config = {}) => APIClient.put(`${APIBusiness}/${resourceName}/Status`, data, config)
const PatchField = (data = {}, config = {}) => APIClient.patch(`${APIBusiness}/${resourceName}`, data, config)

const WorkRepository = {
  GetTeam,
  GetWork,
  GetWorkByRef,
  PutStatus,
  PatchField
}

export default WorkRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/work.js